<template>
  <div v-if="action">
    <div class="modal-card" style="width: 900px; height: auto">
      <section class="modal-card-body">
        <b-notification :closable="false">
          <div class="columns">
            <div class="column is-6">
              <b-field :label="$t('compTransitionActionsView.action-title')">
                <div class="content">{{ action.title }}</div>
              </b-field>
            </div>

            <div class="column">
              <b-field :label="$t('compTransitionActionsView.action-start')">
                <b-icon icon="calendar"></b-icon>
                {{ $d(action.start, 'short') }}
              </b-field>
            </div>

            <div class="column" v-if="action.end">
              <b-field :label="$t('compTransitionActionsView.action-end')">
                <b-icon icon="calendar"></b-icon>
                {{ $d(action.end, 'short') }}
              </b-field>
            </div>
          </div>
          <b-field v-if="action.abandoned">
            <b-switch v-model="action.abandoned">
              {{ $t('compTransitionActionsView.action-abandoned') }}
            </b-switch>
          </b-field>
        </b-notification>

        <b-notification :closable="false">
          <b-field :label="$t('compTransitionActionsView.action-tags')">
            <action-tag-list :tags="action.tags"></action-tag-list>
          </b-field>
        </b-notification>

        <b-notification :closable="false">
          <b-field :label="$t('compTransitionActionsView.action-text')">
            <div class="ql-editor content" v-html="action.text"></div>
          </b-field>
        </b-notification>

        <b-notification :closable="false" v-if="action.files.length > 0">
          <div class="columns">
            <div class="control column">
              <b-field :label="$t('compTransitionActionsView.action-files')">
                <b-taglist>
                  <b-tag
                    v-for="(file, index) in action.files"
                    style="cursor: pointer"
                    :key="index"
                    icon="file"
                    type="is-small"
                    class="ctag"
                    :closable="false"
                    @click="clickFile(file)"
                  >
                    <strong> {{ file.name | truncate(15) }} </strong>
                    <span style="color: #979797">{{
                      file.size | convertFileSize
                    }}</span>
                  </b-tag>
                </b-taglist>
              </b-field>
            </div>
            <div class="column is-3 is-vcentered" v-if="withQuota">
              <quota-status
                :actionSize="action.size"
                :actionQuota="actionQuota"
                :globalSize="quota"
                :globalQuota="maxQuota"
              />
            </div>
          </div>
        </b-notification>
      </section>
    </div>
  </div>
</template>

<script>
import { Background } from '@/mixins/background.js'
import transitionService from '@/services/transitionService.js'
import { openFileAsync } from '../../../models/transition/utils'

export default {
  name: 'ActionView',
  props: {
    action: {
      type: Object,
      required: true
    },
    quota: {
      type: Number,
      required: false,
      default: 0
    },
    maxQuota: {
      type: Number,
      required: false,
      default: 0
    },
    actionQuota: {
      type: Number,
      required: false,
      default: 0
    },
    withQuota: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    'action-tag-list': () =>
      import('@/components/transition/ActionTagList.vue'),
    'quota-status': () => import('../QuotaStatus.vue')
  },

  mixins: [Background],
  methods: {
    clickFile (file) {
      if (file.url) {
        openFileAsync(transitionService.getFile(file), file.name)
      }
    }
  }
}
</script>

<style>
.ql-editor {
  background-color: transparent;
}
</style>
